import { Controller } from "@hotwired/stimulus"

// Canvas/편집 show 페이지용 모바일 뷰-온리 컨트롤러.
// 모바일(≤768px) 에서만 동작:
//   1) 페이지 내 .pw-edit-only 버튼/폼 클릭/submit을 capture phase에서 차단
//   2) 차단 시 사용자에게 안내 토스트 1회
//   3) breakpoint 변경(회전 등)에 반응해 자동 on/off
//
// 사용:
//   <body ... data-controller="canvas-mobile">
//   또는 show 페이지 루트에 `data-controller="canvas-mobile"`
//
// CSS (.pw-edit-only 숨김 규칙)는 workspace.html.erb 레이아웃에서 이미 정의됨.
// 컨트롤러는 클래스 속성이 있어도 JS event로 트리거되는 버튼 안전망 역할.
export default class extends Controller {
  static values = {
    breakpoint: { type: Number, default: 768 },
    noticeText: { type: String, default: "모바일에서는 보기 전용이에요. 편집은 PC에서 해주세요." }
  }

  connect() {
    this.mql = window.matchMedia(`(max-width: ${this.breakpointValue}px)`)
    this.onBreakpoint = this.onBreakpoint.bind(this)
    this.onInteract = this.onInteract.bind(this)

    this.mql.addEventListener("change", this.onBreakpoint)
    this.applyState(this.mql.matches)
    this.noticeShown = false
  }

  disconnect() {
    this.removeInteractListeners()
    this.mql?.removeEventListener("change", this.onBreakpoint)
  }

  onBreakpoint(event) {
    this.applyState(event.matches)
  }

  applyState(isMobile) {
    this.removeInteractListeners()
    if (isMobile) {
      this.addInteractListeners()
    }
  }

  addInteractListeners() {
    this.element.addEventListener("click", this.onInteract, true)
    this.element.addEventListener("submit", this.onInteract, true)
  }

  removeInteractListeners() {
    this.element.removeEventListener("click", this.onInteract, true)
    this.element.removeEventListener("submit", this.onInteract, true)
  }

  onInteract(event) {
    const target = event.target.closest(".pw-edit-only")
    if (!target) return
    event.preventDefault()
    event.stopPropagation()
    this.showNotice()
  }

  showNotice() {
    if (this.noticeShown) return
    this.noticeShown = true

    const toast = document.createElement("div")
    toast.textContent = this.noticeTextValue
    toast.setAttribute("role", "status")
    toast.style.cssText = [
      "position:fixed",
      "left:50%",
      "bottom:24px",
      "transform:translateX(-50%)",
      "background:#111827",
      "color:#fff",
      "padding:12px 20px",
      "font-size:14px",
      "font-weight:500",
      "border-radius:0",
      "box-shadow:0 10px 32px rgba(0,0,0,0.32)",
      "z-index:9999",
      "max-width:calc(100% - 32px)",
      "text-align:center",
      "line-height:1.5"
    ].join(";")
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.remove()
      this.noticeShown = false
    }, 2500)
  }
}
